import { render, staticRenderFns } from "./Akteure.vue?vue&type=template&id=1f67cc2c&"
import script from "./Akteure.vue?vue&type=script&lang=js&"
export * from "./Akteure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports